import ChannelManagerTemplate from "../../../templates/admin/channelManager";

const ChannelManagerScreen = () => {
  return <ChannelManagerTemplate />;
};

export default ChannelManagerScreen;
